import Image from "utils/imageLoader";
import { API_HOST } from "config";

export const PrintInstructions = ({ prototype, specsOpen, setSpecsOpen }) => {
    if (!prototype) return null;
    return (
        <>
            <div className="project-detail-grid">
                <div className="project-detail-sidebar">
                    <Image
                        fileName={prototype?.preview_image_url}
                        alt={prototype?.name}
                        className="project-detail-image"
                    />

                    {/* Specs */}
                    <div className="text-box">
                        <h2
                            onClick={() => setSpecsOpen(!specsOpen)}
                            style={{ cursor: "pointer", userSelect: "none" }}
                        >
                            Print Specifications {specsOpen ? "▼" : "▶"}
                        </h2>
                        {specsOpen && (
                            <dl className="specs-list">
                                {prototype?.material_list && (
                                    <>
                                        <dt>Materials:</dt>
                                        <dd>
                                            {prototype.material_list.join(", ")}
                                        </dd>
                                    </>
                                )}
                                {prototype?.infill_range && (
                                    <>
                                        <dt>Infill Range:</dt>
                                        <dd>
                                            {prototype.infill_range.join(
                                                " - "
                                            ) + "%"}
                                        </dd>
                                    </>
                                )}
                                {prototype?.support_material_requirements && (
                                    <>
                                        <dt>Support Material:</dt>
                                        <dd>
                                            {prototype.support_material_requirements
                                                .charAt(0)
                                                .toUpperCase() +
                                                prototype.support_material_requirements.slice(
                                                    1
                                                )}
                                        </dd>
                                    </>
                                )}
                                {prototype?.estimated_print_time && (
                                    <>
                                        <dt>Estimated Print Time:</dt>
                                        <dd>
                                            {prototype.estimated_print_time +
                                                " hours"}
                                        </dd>
                                    </>
                                )}
                                {prototype?.estimated_total_weight && (
                                    <>
                                        <dt>Estimated Total Weight:</dt>
                                        <dd>
                                            {prototype.estimated_total_weight +
                                                " grams"}
                                        </dd>
                                    </>
                                )}
                            </dl>
                        )}
                    </div>
                </div>

                <div className="project-detail-content">
                    <h1 className="section-title">{prototype.name}</h1>
                    <p className="lead">{prototype?.summary}</p>

                    {prototype?.about && (
                        <div className="text-box">
                            <h2>About This Project</h2>
                            <p>{prototype.about}</p>
                        </div>
                    )}
                    {prototype?.features && prototype.features.length > 0 && (
                        <div className="text-box">
                            <h2>Features</h2>
                            <ul className="feature-list">
                                {prototype.features.map((feature, index) => (
                                    <li key={index}>{feature}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            </div>
            {prototype?.component_list &&
                prototype.component_list.length > 0 && (
                    <div className="text-box files-section">
                        <h2>Download Files</h2>
                        <div className="files-list">
                            {prototype?.component_list.map(
                                (component, index) => (
                                    <div key={index} className="file-item">
                                        <Image
                                            fileName={
                                                component?.preview_image_url ||
                                                null
                                            }
                                            alt={component?.part_name || "STL"}
                                            className="file-preview"
                                        />

                                        <div className="file-info">
                                            <span className="file-name">
                                                {component.part_name}
                                            </span>
                                            {component?.material_type && (
                                                <span className="component-info">
                                                    Material:{" "}
                                                    {component.material_type}
                                                </span>
                                            )}
                                            {component?.infill_percentage && (
                                                <span className="component-info">
                                                    Infill:{" "}
                                                    {
                                                        component.infill_percentage
                                                    }{" "}
                                                    %
                                                </span>
                                            )}
                                            {component?.color && (
                                                <span className="component-info">
                                                    Color: {component.color}
                                                </span>
                                            )}
                                            {component?.count && (
                                                <span className="component-info">
                                                    Print count:{" "}
                                                    {component.count}
                                                </span>
                                            )}
                                        </div>
                                        {component.stl_file_url ? (
                                            <a
                                                href={`${API_HOST}${component.stl_file_url}`}
                                                download
                                                className="btn btn-primary btn-sm"
                                            >
                                                Download
                                            </a>
                                        ) : (
                                            <a
                                                href="/#signup"
                                                className="btn btn-primary btn-sm"
                                            >
                                                Join Waitlist
                                            </a>
                                        )}
                                    </div>
                                )
                            )}
                        </div>
                    </div>
                )}
        </>
    );
};
